import React from "react";
import { Breadcrumb } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getItem, setItem } from "../../common/localStorage";
import breadcrumb from "../../assets/images/breadcrumb.svg";
import notificationIcon from "../../assets/images/notificationIcon.svg";
import mobileMenu from "../../assets/images/mobileMenu.svg";
import backBtn from "../../assets/images/backBtn.svg";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { t } = useTranslation();

  const getNotificationsCountsSelector = useSelector(
    (state) => state?.getNotificationsCounts
  );

  const getAllProductListSelector = useSelector(
    (state) => state?.getProductList
  );

  const backPathsMobile = [
    "/product-info",
    "/dpcextra",
    "/support-request",
    "/manage-notification",
    "/profile-change",
  ];
  const isBackPath = backPathsMobile?.includes(location?.pathname);

  const getHeaderTitle = () => {
    const pathname = location?.pathname;

    switch (pathname) {
      case "/profile-change":
        return t("Profile");
      case "/support-request":
        return t("Support Request");
      case "/manage-notification":
        return t("Manage Notifications");
      case "/product-info":
        return (
          getItem("featureName") ||
          getAllProductListSelector?.data?.data?.products?.[0]?.productName ||
          ""
        );
      case "/dpcextra":
        return state?.itemData?.name || "";
      default:
        return "";
    }
  };

  const handleMenuClick = () => {
    if (isBackPath) {
      navigate(-1);
    } else if (onMenuClick) {
      onMenuClick();
    }
  };

  const breadcrumbPages = [
    "/profile-change",
    "/manage-notification",
    "/support-request",
    "/product-info",
    "/dpcextra",
  ];

  const showBreadcrumb = breadcrumbPages.includes(location?.pathname);

  return (
    <div className="header">
      <div className="headerFlex">
        <div
          className="mobileShow cursor-pointer"
          onClick={handleMenuClick}
        >
          <img src={isBackPath ? backBtnMobile : mobileMenu} alt="" />
        </div>

        <div className="breadcrumbAboslute justify-lg-center d-flex gap-10 align-center">
          {showBreadcrumb && (
            <img
              src={backBtn}
              onClick={() => navigate(-1)}
              className="cursor-pointer backBtn"
              alt=""
            />
          )}
          {showBreadcrumb ? (
            <div>
              <h2 className="pageName fs-20 fw-600 mb-10">
                {getHeaderTitle()}
              </h2>
              <Breadcrumb
                className="breadcrumb cursor-pointer"
                separator={
                  <span>
                    <img src={breadcrumb} alt="" />
                  </span>
                }
                items={[
                  {
                    title: ["/product-info", "/dpcextra"].includes(
                      location?.pathname
                    )
                      ? t("Products")
                      : t("Settings"),
                    onClick: [
                      "/profile-change",
                      "/manage-notification",
                      "/support-request",
                      "/product-info",
                    ].includes(location?.pathname)
                      ? () =>
                          navigate(
                            location?.pathname === "/product-info"
                              ? "/dashboard"
                              : "/settings"
                          )
                      : undefined,
                  },
                  {
                    title:
                      location?.pathname === "/product-info" ||
                      location?.pathname === "/dpcextra"
                        ? getItem("featureName")
                        : undefined,
                    onClick:
                      location?.pathname === "/dpcextra" &&
                      getItem("featureName")
                        ? () =>
                            navigate("/product-info", {
                              state: state?.stateDashboard,
                            })
                        : undefined,
                  },
                  {
                    title:
                      location?.pathname === "/dpcextra"
                        ? getItem("innerFeature")
                        : undefined,
                  },
                  {
                    title:
                      location?.pathname === "/manage-notification"
                        ? t("Manage Notifications")
                        : location?.pathname === "/product-info" ||
                          location?.pathname === "/dpcextra"
                        ? getItem("productName") || t("Profile")
                        : location?.pathname === "/support-request"
                        ? t("Support Request")
                        : t("Profile"),
                  },
                ]}
              />
            </div>
          ) : (
            <h2 className="pageName fs-20 fw-600 mb-10">
              {location?.pathname === "/dashboard"
                ? (() => {
                    const stored = getItem("productName");
                    const firstProduct =
                      getAllProductListSelector?.data?.data?.products?.[0]
                        ?.productName;
                    if (!stored && firstProduct) {
                      setItem("productName", firstProduct);
                      return firstProduct;
                    }
                    return stored;
                  })()
                : t(
                    location?.pathname
                      ?.split("/")
                      .filter(Boolean)
                      .map(
                        (part) =>
                          part.charAt(0).toUpperCase() + part.slice(1)
                      )
                      .join(" / ")
                  )}
            </h2>
          )}
        </div>
        <div
          className="cursor-pointer badge"
          onClick={() => navigate("/notification")}
        >
          <img src={notificationIcon} alt="" />
          <sup>
            {getNotificationsCountsSelector?.data?.data?.notificationCount}
          </sup>
        </div>
      </div>
    </div>
  );
};

export default Header;

